
import { ProductModel } from '@/models'

const fetchBySearch = async function (search) {
    try {
        const product = await ProductModel.where('alias_search', search).get()
        return product.data
    } catch ( error ) {
        return error.response.data
    }
}

export default fetchBySearch
